export default {
  username: '',
  phoneNumber: '',
  validationKey: '',
  validationId: null,
  __typename: 'FindPassword'
};
